import React, { useEffect, useState } from 'react';
import { event } from '../data/masterclass';
type Remaining = {
  days: number;
  hours: number;
  minutes: number;
};
function getRemaining(target: number): Remaining {
  const diff = Math.max(0, target - Date.now());
  return {
    days: Math.floor(diff / 86400000),
    hours: Math.floor(diff / 3600000 % 24),
    minutes: Math.floor(diff / 60000 % 60)
  };
}
export function Countdown() {
  const target = new Date(event.isoDate).getTime();
  const [remaining, setRemaining] = useState<Remaining>(() => getRemaining(target));
  useEffect(() => {
    const id = window.setInterval(() => setRemaining(getRemaining(target)), 30000);
    return () => window.clearInterval(id);
  }, [target]);
  const units: Array<[number, string]> = [[remaining.days, 'Days'], [remaining.hours, 'Hours'], [remaining.minutes, 'Minutes']];
  return <div className="w-full" role="timer" aria-label="Time until the masterclass begins" data-id="element-22" data-mp="15by6dqqwyhnl">
      <p className="text-[11px] font-bold uppercase tracking-overline text-white/45" data-id="element-23" data-mp="y04xe63v9qs3">
        Doors open in
      </p>
      <div className="mt-4 grid grid-cols-3 gap-3 sm:gap-5" data-id="element-24" data-mp="t1adf0u5xw6e">
        {units.map(([value, label]) => <div key={label} className="rounded-2xl border border-gold/35 bg-ink/80 px-2 py-6 sm:py-8" data-id="element-25" data-mp="17qgeyvgh3yhg">
            <div className="font-display text-6xl font-bold leading-none text-gold tabular-nums sm:text-7xl lg:text-8xl" data-id="element-26" data-mp="f2atu7lic7h3">
              {String(value).padStart(2, '0')}
            </div>
            <div className="mt-3 text-[11px] font-semibold uppercase tracking-overline text-white/55" data-id="element-27" data-mp="a5kclgxyv5u3">
              {label}
            </div>
          </div>)}
      </div>
    </div>;
}